export const depotStatusOptions = [
  { value: 'coleta_no_porto', label: 'COLETA PORTO' },
  { value: 'baixado_aguardando_cheio_barra_velha', label: 'BX CHEIO BV' },
  { value: 'baixado_aguardando_cheio_itapoa', label: 'BX CHEIO ITA' },
  { value: 'baixado_aguardando_vazio_barra_velha', label: 'BX VAZIO BV' },
  { value: 'baixado_aguardando_vazio_itapoa', label: 'BX VAZIO ITA' },
  { value: 'finalizado', label: 'FINALIZADO' },
];

export const formatDepotStatusToSelect = (value) => {
  if (!value) return null;

  const found = depotStatusOptions.find((option) => option.value === value);
  return found || { value, label: String(value).replace(/_/g, ' ').toUpperCase() };
};
